import { css } from 'twin.macro';
import { useSuccessfulLogin } from '@auth_module/hooks/useSuccessfulLogin';
import { Layout } from '@auth_module/components/Layout';
import { RegisterForm } from '@auth_module/components/RegisterForm';
import { withTitle } from '@hoc/withTitle';
import { useAuthParams } from '@auth_module/hooks/useAuthParams';
import { InsightsTermsOfServiceModal } from '@auth_module/components/InsightsTermsOfServiceModal';
import registerGraphic from '@assets/images/register-graphic.svg';

const backgroundImage = css`
  background-image: url(${registerGraphic});
`;

const _RegisterPage = () => {
  const { handleSuccessLogin } = useSuccessfulLogin({ navigateTo: '/' });

  const [{ invite_token: inviteToken, email: inviteEmail }] = useAuthParams();

  return (
    <>
      <Layout tw='md:top-[calc(50% - 262px)] md:max-w-[550px]' backgroundCss={backgroundImage}>
        <RegisterForm
          inviteToken={inviteToken as string}
          inviteEmail={inviteEmail as string}
          handleSuccessLogin={handleSuccessLogin}
        />
      </Layout>

      <InsightsTermsOfServiceModal />
    </>
  );
};

export const RegisterPage = withTitle(_RegisterPage, 'auth.register_page.title');
